module.exports = __webpack_public_path__ + "img/npm.bd0e2330.svg";